import React, { Component } from "react";
import CommonDropdown from "./../../components/commonDropdown";
import InputField from "../../components/InputFieldComponent";

import Availability from "./../TutorDashboard/availability";
import { Col, Row, Image, Button } from "react-bootstrap";
import { connect } from "react-redux";

class BookingRequest extends Component {
  constructor() {
    super();
    this.state = {
      availability: [
        {
          timeStatus: "Morning",
          time: "Pre 12am",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Afternoon",
          time: "12 - 3pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "unavailable",
            fri: "unavailable",
            sat: "available",
            sun: "unavailable",
          },
        },
        {
          timeStatus: "Late Afternoon",
          time: "4 - 6pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Evening",
          time: "6 - 8pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
        {
          timeStatus: "Late Evening",
          time: "After 8pm",
          week: {
            mon: "unavailable",
            tues: "available",
            wed: "unavailable",
            thus: "available",
            fri: "unavailable",
            sat: "unavailable",
            sun: "available",
          },
        },
      ],
      studentWish: "",
    };
  }
  componentDidMount = () => {
    const { tutorSpecficData } = this.props;

    let subject = tutorSpecficData?.subjectName;
    let level = tutorSpecficData?.levelName;

    this.setState({
      subject,
      level,
      tutorSpecficData,
    });
  };
  componentDidUpdate = (prevProps) => {
    const { tutorSpecficData } = this.props;

    if (tutorSpecficData?.userId !== prevProps?.tutorSpecficData?.userId) {
      let subject = tutorSpecficData?.subjectName;
      let level = tutorSpecficData?.levelName;

      this.setState({
        subject,
        level,
        tutorSpecficData,
      });
    }
  };

  render() {
    const {
      availability,
      studentWish,
      subject,
      level,
      tutorSpecficData,
    } = this.state;

    const {
      match: {
        params: { id },
      },
    } = this.props;
    let firstName = tutorSpecficData?.firstName;
    let lastName = tutorSpecficData?.lastName;

    return (
      <div>
        <Row>
          <Col lg={6} md={12} sm={12} xs={12} className="request-booking-col">
            <h2 className="truncate" id="availabilty">
              Availability
            </h2>
            <Availability
              tutor={true}
              availability={availability}
              isStudentsearch={true}
              forBooking={true}
              firstName={firstName}
              lastName={lastName}
            />
            <div className="contact-to-div">
              <p className="contact-to-tutor-para">
                Contact Christopher to check fr specific availability, or if you
                have a specific requirment about the subject you wish to learn
              </p>
              <div className="flex-center">
                <span className="green-txt">Contact tutor</span>
                <span className="green-txt">Request availability</span>
              </div>
            </div>
          </Col>
          <Col
            lg={6}
            md={12}
            sm={12}
            xs={12}
            className="booking-request-Form-Col"
          >
            <Col lg={12} md={12} sm={12} xs={12}>
              <div className="booking-request-Form">
                <h2
                  className="truncate"
                  style={{ color: "#000", padding: "0px 30px" }}
                  id="availabilty"
                >
                  Booking request
                </h2>
                <div className="flex-between-center header-dv">
                  <div className="common-para">
                  Select availability to book
                  </div>
                  
                </div>
                <Row style={{ padding: "0px 30px" }}>
                  <Col
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    className="sub-Col"
                   
                  >
                    {/* <InputField
                      InputHeadTitle={"Subject"}
                      value={subject ? subject : ""}
                      disabled={true}
                      image={require("./../../assets/icons/lock.png")}
                    /> */}
                    <CommonDropdown
                      headtitleInUnder={"Subject"}
                      style={{
                        dropdownParentStyle:{
                          borderBottom:"none",
                          borderRadius: "0px",
                          borderRight:"none",

                        },
                        headtitleInUnderStyle: {
                          fontFamily: "OpenSans, Arial, sans-serif",
                          fontSize: "12px",
                          fontWeight: "normal",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.58",
                          letterSpacing: "0.06px",
                          textAlign: "left",
                          color: "#8f8f8f",
                        },
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.19",
                        letterSpacing: "0.08px",
                        textAlign: "left",
                        color: "#484848",
                        marginBottom: "0px",
                      }}
                    />
                  </Col>
                  <Col
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                   className="level-Col"
                  >
                    {/* <InputField
                      InputHeadTitle={"Level"}
                      value={level ? level : ""}
                      disabled={true}
                      image={require("./../../assets/icons/lock.png")}
                    /> */}
                    <CommonDropdown
                      headtitleInUnder={"Level"}
                      style={{
                        dropdownParentStyle:{
                          borderBottom:"none",
                          borderRadius: "0px",
                        },
                        headtitleInUnderStyle: {
                          fontFamily: "OpenSans, Arial, sans-serif",
                          fontSize: "12px",
                          fontWeight: "normal",
                          fontStretch: "normal",
                          fontStyle: "normal",
                          lineHeight: "1.58",
                          letterSpacing: "0.06px",
                          textAlign: "left",
                          color: "#8f8f8f",
                        },
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "16px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.19",
                        letterSpacing: "0.08px",
                        textAlign: "left",
                        color: "#484848",
                        marginBottom: "0px",
                      }}
                    />
                  </Col>
                </Row>
                <div style={{ padding: "0px 30px" }}>
                  <InputField
                    headtitleInUnder={"Describe What you wish to learn?"}
                    style={{
                      UnderStyleP: {
                        borderRadius: "3px",
                        border: "solid 0.5px #ccc",
                      },
                      headtitleInUnderStyle: {
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.58",
                        letterSpacing: "0.06px",
                        textAlign: "left",
                        color: "#8f8f8f",
                        padding: "0.375rem 0.75rem",
                      },
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.19",
                      letterSpacing: "0.08px",
                      textAlign: "left",
                      color: "#484848",
                      height: "96px",
                    }}
                  />

                  {/* <hr /> */}
                  {/* <div className="section-header">
                  Describe What you wish to learn?
                </div>
                <Form.Control
                  className="form_textarea grey-txt-bold"
                  as="textarea"
                  name="studentWish"
                /> */}
                  {/* <div className="count-stu">{`${studentWish.length}/350`}</div> */}

                  <CommonDropdown
                    headtitleInUnder={
                      "Where would you like to take your lessons?"
                    }
                    style={{
                      dropdownParentStyle:{
                        borderBottom:"none",
                        borderRadius: "0px",
                      
                      },
                      headtitleInUnderStyle: {
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.58",
                        letterSpacing: "0.06px",
                        textAlign: "left",
                        color: "#8f8f8f",
                      },
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.19",
                      letterSpacing: "0.08px",
                      textAlign: "left",
                      color: "#484848",
                      marginBottom: "0px",
                    }}
                  />
                  <InputField
                    headtitleInUnder={"Full addres"}
                    style={{
                      UnderStyleP: {
                        borderRadius: "3px",
                        border: "solid 0.5px #ccc",
                      },
                      headtitleInUnderStyle: {
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.58",
                        letterSpacing: "0.06px",
                        textAlign: "left",
                        color: "#8f8f8f",
                        padding: "0.375rem 0.75rem",
                      },
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.19",
                      letterSpacing: "0.08px",
                      textAlign: "left",
                      color: "#484848",
                    }}
                  />
                  <div
                    className="common-para"
                    style={{ color: "#2e2e2e", fontSize: "12px" }}
                  >
                    We require the full address where you wish to take the
                    lesson. This will only be provided to your tutor ones they
                    accept booking.
                  </div>
                  <div style={{ marginBottom: "30px" }} />

                  {/* <CommonDropdown dropdownTitle={"Lesson duration?"} /> */}
                  <CommonDropdown
                    headtitleInUnder={"Lesson duration?"}
                    style={{
                      dropdownParentStyle:{
                        borderBottom:"none",
                        borderRadius: "0px",
                      
                      },
                      headtitleInUnderStyle: {
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.58",
                        letterSpacing: "0.06px",
                        textAlign: "left",
                        color: "#8f8f8f",
                      },
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.19",
                      letterSpacing: "0.08px",
                      textAlign: "left",
                      color: "#484848",
                      marginBottom: "0px",
                    }}
                  />
                  <CommonDropdown
                    headtitleInUnder={
                      "How often would you like to take your sessions?"
                    }
                    style={{
                      dropdownParentStyle:{
                        borderRadius: "0px",
                      
                      },
                      headtitleInUnderStyle: {
                        fontFamily: "OpenSans, Arial, sans-serif",
                        fontSize: "12px",
                        fontWeight: "normal",
                        fontStretch: "normal",
                        fontStyle: "normal",
                        lineHeight: "1.58",
                        letterSpacing: "0.06px",
                        textAlign: "left",
                        color: "#8f8f8f",
                      },
                      fontFamily: "OpenSans, Arial, sans-serif",
                      fontSize: "16px",
                      fontWeight: "normal",
                      fontStretch: "normal",
                      fontStyle: "normal",
                      lineHeight: "1.19",
                      letterSpacing: "0.08px",
                      textAlign: "left",
                      color: "#484848",
                      marginBottom: "0px",
                    }}
                  />
                  {/*               
                <CommonDropdown
                dropdownTitle={
                  "How often would you like to take your sessions?"
                }
              /> */}
                  <div
                    className="flex-between-center"
                    style={{ marginTop: "30px" }}
                  >
                    <div className="cancel-div">
                      <Image
                        src={require("./../../assets/icons/next-black.png")}
                        style={{
                          transform: "rotate(180deg)",
                          width: "13.6px",
                        }}
                      />
                      Back
                    </div>
                    <Button
                      className="continue-btn"
                      style={{
                        width: "108px",
                        height: "44px",
                        borderRadius: "5px",
                        padding: "0px",
                        fontSize: "16px",
                        fontFamily: "CircularStdMedium, Arial, sans-serif",
                      }}
                      onClick={() =>
                        this.props.history.push(
                          `/tutors/search/tutor/${id}/request-session`
                        )
                      }
                    >
                      Continue
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    TutorListReducer: { tutorListCheck, tutorSpecficData },
  } = state;

  return {
    tutorListCheck,
    tutorSpecficData,
  };
};

export default connect(mapStateToProps, null)(BookingRequest);
